import type { SxProps, Theme } from '@mui/material';

// Shared DataGrid styling for the Browse / My Apps list views: clickable rows,
// a distinct header band, roomier cells, and NO cell-focus outline — the row
// hover + the modal-on-click are the salient affordances, so the green
// highlight on the clicked cell only added confusion.
export const listGridSx: SxProps<Theme> = {
  '& .MuiDataGrid-row': { cursor: 'pointer' },
  // With auto row height, plain-text cells (Category) top-align while flex
  // cells center — force every cell to center vertically.
  '& .MuiDataGrid-cell': { py: 1, display: 'flex', alignItems: 'center' },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeaders': { backgroundColor: 'action.hover' },
  '& .MuiDataGrid-columnHeader': { backgroundColor: 'transparent' },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: '0.72rem',
    letterSpacing: '0.06em',
  },
};
